/**
 * Supervisor Profile Page - Microsoft 365 Style
 * View supervisor details and assignments
 */

import React from 'react';
import { makeStyles, Text } from '@fluentui/react-components';
import { ContentCard } from '../../../components/layout';

const useStyles = makeStyles({
  pageHeader: { marginBottom: '24px' },
  pageTitle: { fontSize: '24px', fontWeight: '600', color: '#323130' },
});

export const SupervisorProfileFluentUI: React.FC = () => {
  const styles = useStyles();

  return (
    <div>
      <div className={styles.pageHeader}>
        <Text className={styles.pageTitle}>Supervisor Profile</Text>
      </div>

      <ContentCard>
        <Text>Supervisor profile and zone assignments - Feature in development</Text>
      </ContentCard>
    </div>
  );
};

export default SupervisorProfileFluentUI;
